<template>
  <div class="ren-decoration-cp ren-decoration-cp-search">
    <span>{{ placeholder }}</span>
    <i :style="{ backgroundColor: buttonColor }">{{ buttonText }}</i>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const placeholder = computed(() => {
  const value = props.component.props?.placeholder
  return value == null || String(value).trim() === '' ? '请输入搜索内容' : String(value)
})

const buttonText = computed(() => {
  const value = props.component.props?.buttonText
  return value == null || String(value).trim() === '' ? '搜索' : String(value)
})

const buttonColor = computed(
  () => props.themeColor || props.themeTokens?.primaryColor || 'var(--ren-theme-primary)'
)
</script>
